import React from 'react';
import BaseComponent, {AjaxParam} from '../../common/BaseComponent/BaseComponent';

import Radio from "../../common/primitives/Radio";
import Button from "../../common/primitives/Button";
import CloseButton from "../../common/primitives/CloseButton";
import radioStyles from '../../common/primitives/Radio.scss';
import buttonStyles from '../../common/primitives/Button.scss';
import styles from './ComponentSelectMainDomain.scss';

import LoadingRow from "../../common/primitives/LoadingRow";
import {ContextDataStore} from "../../common/helpers/HelperGlobalDataStore";
import {__t} from '../../common/lang/text-resource';

class ComponentSelectMainDomain extends BaseComponent {

	selected = '';
	loading = false;

	constructor(props) {
		super(props);
		const domains = this.state.componentData;
		domains.map((domain) => {
			if (domain.selected) {
				this.selected = domain.id;
			}
		});

	}

	componentDidMount() {
		super.componentDidMount();
		document.addEventListener('keydown', this.onEsc, false);
	}

	componentWillUnmount() {
		document.removeEventListener('keydown', this.onEsc, false);
	}

	onEsc = (event) => {
		if (event.keyCode === 27) {
			this.props.toggleMainDomainSelect();
		}
	};

	submit = () => {
		let ajaxParam = new AjaxParam();
		ajaxParam.callbackSuccess = () => {
			this.eventRaise('MainDomainChanged');
		};
		this.ajaxCall('ActionChangeMainDomain', {lineId: this.selected}, ajaxParam);
	};

	onChange = event => {
		const value = event.target.value;
		let domains = this.state.componentData;
		domains.map((domain, key) => {
			if (domain.id === value) {
				domains[key].selected = 1;
				this.selected = domain.id;
			} else {
				domains[key].selected = 0;
			}
		});
		this.state.componentData = domains;
		this.setState(this.state);
	};

	render() {
		const domains = this.state.componentData;
		return (
		  <section className={`${styles.container}`}>

			  <div className={styles.closeButton}>
				  <CloseButton onClick={this.props.toggleMainDomainSelect} altText={__t("Затвори")}/>
			  </div>
			  <div className={styles.content}>
				  <div>
					  <div>
						  <h1 data-layout="text-center">{__t('Основен домейн')}</h1>
					  </div>
					  <div data-layout="margin-top--lg padding-top--xxs">

						  <div data-layout="row start gutter-none" className={styles.domainsHolder}>
							  {
								  domains.map((domain, key) =>
									<div key={key} data-layout="col 6@sm">
										<Radio
										  label={domain.name}
										  value={domain.id}
										  checked={domain.selected === 1 || domain.selected === true}
										  name={'main_domain'}
										  onChange={this.onChange}
										  checkmarkClass={radioStyles.transparent}/>
									</div>)
							  }
						  </div>
					  </div>
					  <div data-layout="text-center margin-top--md">
						  {
							  (!this.loading) ?
								<div>

									<Button onClick={this.submit} name={'do_save'} value={__t('Запазване')}/>
									<br/><br/>
									<Button
									  className={`${buttonStyles.buttonLink} ${buttonStyles.action} ${styles.selectMainDomainLink}`}
									  onClick={() => this.navigate('/web-hosting-order-hosting-domain.php')}
									  name={'do_search_new'} value={__t('Регистрация на домейн')}/>
								</div> :
								<div className={styles.loadingContainer}>
									<LoadingRow/>
								</div>
						  }
					  </div>
				  </div>
			  </div>
		  </section>
		);
	}
}


// React Context binding
ComponentSelectMainDomain.contextType = ContextDataStore;

export default ComponentSelectMainDomain;